module.exports = "<p-overlayPanel \r\n    #logoutOverlay \r\n    [style]=\"{'min-width': '140px'}\" \r\n    [dismissable]=\"true\" \r\n    [showCloseIcon]=\"false\"\r\n>\r\n    <div><label class=\"bold line-height-20\">{{userName}}</label></div>\r\n    <div><label>{{userId}}</label></div>\r\n    <div><label>{{role}}</label></div>\r\n    <button class=\"margin-top-10\" pButton [label]=\"signOut\" [routerLink]=\"['logout']\"></button>\r\n</p-overlayPanel>"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/authentication/logout/logout.component.html
// module id = ../../../../../src/app/authentication/logout/logout.component.html
// module chunks = main